module.exports = __webpack_public_path__ + "static/media/Long Beach.50c05325.png";